import MyDepartment from "./myDepartment";
export default MyDepartment;